import { query } from './doh';
import './app.css';

const resolver = 'cloudflare-dns.com';

function makeQuery(name, rrtype) {
    return {
        flags: { RD: 1 },
        questions: [{ CLASS: 'IN', NAME: name, TYPE: rrtype }],
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    const domain = 'grebedoc.dev';

    const { answers: aAnswers } = await query(makeQuery(domain, 'A'), resolver);
    const { answers: aaaaAnswers } = await query(makeQuery(domain, 'AAAA'), resolver);
    const { answers: txtAnswers } = await query(makeQuery(`_git-pages-challenge.${domain}`, 'TXT'), resolver);

    let content = `\
A:    ${aAnswers.map((a) => a.RDATA)}
AAAA: ${aaaaAnswers.map((a) => a.RDATA)}
TXT:  ${txtAnswers.map((a) => a.RDATA)}
`;

    const root = document.getElementById('root');
    root.innerText = content;
    root.style.fontFamily = 'monospace';
    root.style.whiteSpace = 'pre-wrap';
});
